// import external dependencies
// import 'jquery';

import Menu from './components/menu'
import HeaderSearch from './components/header-search'

import VideoAutoplay from './components/video/autoplay';
import FooterNewsletter from './components/forms/footer-newsletter';
import Tabs from './components/tabs';
import Accordion from './components/accordion';
import FilterGrid from './components/filter-grid';

import ParallaxFeature from './modules/parallax-feature';
import SideTabContent from './modules/side-tab-content';
import Carousel from './modules/carousel';
import Gallery from './modules/carousel/gallery';
import VideoButton from './components/video-button';
import Leadership from './modules/leadership';
import Map from './modules/map';

import modals from './components/modal'
import forms from './components/forms';

document.addEventListener('DOMContentLoaded', () => {

  modals.init();

  (new Menu(document.querySelector('.header'))).init();
  (new HeaderSearch(document.querySelector('.nav-secondary'))).init();

  document.querySelectorAll('.modules-side-tab-content').forEach((moduleElement) => {
    (new SideTabContent(moduleElement)).init()
  })

  document.querySelectorAll('.tabs').forEach((tabElement) => {
    (new Tabs(tabElement)).init()
  })

  document.querySelectorAll('.accordion').forEach((accordionElement) => {
    (new Accordion(accordionElement)).init()
  })

  document.querySelectorAll('[data-video-src]').forEach((video) => {
    (new VideoAutoplay(video)).init()
  })

  document.querySelectorAll('[data-footer-mc-form]').forEach((form) => {
    (new FooterNewsletter(form)).init()
  })

  document.querySelectorAll('.modules-parallax-feature').forEach((feature) => {
    (new ParallaxFeature(feature)).init()
  })

  document.querySelectorAll('.modules-testimonial-carousel').forEach((testimonialCarousel) => {
    (new Carousel(testimonialCarousel)).init()
  })

  document.querySelectorAll('.modules-image-gallery').forEach((imageGallery) => {
    (new Carousel(imageGallery)).init()
  })

  document.querySelectorAll('.gallery').forEach((gallery) => {
    (new Gallery(gallery)).init()
  })

  document.querySelectorAll('.js-play-btn').forEach((btn) => {
    (new VideoButton(btn)).init()
  })

  document.querySelectorAll('.modules-leadership').forEach((leadershipModule) => {
    (new Leadership(leadershipModule)).init()
  })

  document.querySelectorAll('.modules-map').forEach((map) => {
    (new Map(map)).init()
  })

  const filterGrid = document.querySelector('.js-filter-grid');
  if (filterGrid) {
    (new FilterGrid(filterGrid)).init()
  }

  forms.init()
})
